// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1IWcr","amount":"Amount_amount__9y7Zw","tip":"Amount_tip__5hv1j","tipHeader":"Amount_tipHeader__3T-xP","tipsWrap":"Amount_tipsWrap__1hPLt"};